import { Space, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const SpinnerButton = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 8px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

const IconWrapper = styled.div`
  margin-right: 8px;
  display: flex;
  align-items: center;
`;

const Spinner = ({ text, color = 'rgba(0, 0, 0, 0.7)', onClick }) => {
  return (
    <SpinnerButton onClick={onClick}>
      <IconWrapper>
        <LoadingOutlined style={{ color, fontSize: '20px' }} spin />
      </IconWrapper>
      <Typography.Text style={{ color, fontWeight: '500' }}>{text}</Typography.Text>
    </SpinnerButton>
  );
};

export default Spinner;
